<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-content">
        <div class="footer-logo">
          <h2>{{ footerContent.logo_title }}</h2>
          <p>{{ footerContent.logo_subtitle }}</p>
        </div>
        <div class="footer-contact">
          <h3>{{ footerContent.contact_title }}</h3>
          <p v-for="(line, index) in getAddressLines()" :key="index" v-html="line"></p>
          <p v-html="footerContent.contact_email"></p>
        </div>
        <div class="footer-links">
          <h3>{{ footerContent.links_title }}</h3>
          <ul>
            <li v-for="(link, index) in footerContent.links" :key="index">
              <router-link :to="link.url">{{ link.name }}</router-link>
            </li>
          </ul>
        </div>
      </div>
      <div class="footer-bottom">
        <p>&copy; {{ new Date().getFullYear() }} ateloacademy. All Rights Reserved.</p>
        <p>Powered by <a href="https://oo-sawa.co.jp/" target="_blank" rel="noopener noreferrer" class="company-link">大澤商事株式会社</a></p>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { ref, onMounted } from 'vue';

// Footer content state
const footerContent = ref({
  logo_title: '皆の英語教室',
  logo_subtitle: '自信を持って英語を学ぶ。',
  contact_title: 'お問い合わせ',
  contact_address: '📍 中崎町ホール\n〒530-0015\n大阪府大阪市北区中崎西1丁目6-8',
  contact_email: '✉️ ateloetti@gmail.com',
  links_title: 'クイックリンク',
  links: [
    { name: 'ホーム', url: '/' },
    { name: 'コース', url: '/courses' },
    { name: '教室について', url: '/about' },
    { name: 'お知らせ', url: '/notices' },
    { name: 'お問い合わせ', url: '/contact' }
  ]
});

// Fetch footer content
const fetchFooterContent = async () => {
  try {
    const response = await fetch('https://enen.saitsuki.uk/api/page-content/footer');
    if (response.ok) {
      const data = await response.json();
      const content = data.data;
      
      footerContent.value = {
        logo_title: content.footer_logo_title || '皆の英語教室',
        logo_subtitle: content.footer_logo_subtitle || '自信を持って英語を学ぶ。',
        contact_title: content.footer_contact_title || 'お問い合わせ',
        contact_address: content.footer_contact_address || '📍 中崎町ホール\n〒530-0015\n大阪府大阪市北区中崎西1丁目6-8',
        contact_email: content.footer_contact_email || '✉️ ateloetti@gmail.com',
        links_title: content.footer_links_title || 'クイックリンク',
        links: content.footer_links ? JSON.parse(content.footer_links) : [
          { name: 'ホーム', url: '/' },
          { name: 'コース', url: '/courses' },
          { name: '教室について', url: '/about' },
          { name: 'お知らせ', url: '/notices' },
          { name: 'お問い合わせ', url: '/contact' }
        ]
      };
    }
  } catch (error) {
    console.error('Footer content fetch error:', error);
  }
};

// Split address lines for display
const getAddressLines = () => {
  return footerContent.value.contact_address.split('\n').filter(line => line.trim());
};

onMounted(() => {
  fetchFooterContent();
});
</script>

<style scoped>
.footer {
  background-color: #f8f9fa;
  padding: 50px 0 20px;
  margin-top: 50px;
}

.footer-content {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 30px;
}

.footer-logo {
  flex: 1;
  min-width: 200px;
  margin-bottom: 20px;
}

.footer-logo h2 {
  color: var(--primary-color);
  margin-bottom: 10px;
}

.footer-contact {
  flex: 1;
  min-width: 200px;
  margin-bottom: 20px;
}

.footer-contact h3, .footer-links h3 {
  margin-bottom: 15px;
  font-size: 18px;
  color: #333;
}

.footer-contact p {
  margin-bottom: 5px;
  color: #666;
}

.footer-links {
  flex: 1;
  min-width: 200px;
}

.footer-links ul {
  list-style: none;
}

.footer-links li {
  margin-bottom: 10px;
}

.footer-links a {
  text-decoration: none;
  color: #666;
  transition: color 0.3s ease;
}

.footer-links a:hover {
  color: var(--primary-color);
}

.footer-bottom {
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid #ddd;
  color: #999;
}

.footer-bottom p {
  margin: 5px 0;
}

.company-link {
  color: var(--primary-color);
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s ease;
}

.company-link:hover {
  color: var(--secondary-color);
  text-decoration: underline;
}

@media (max-width: 768px) {
  .footer-content {
    flex-direction: column;
  }
  
  .footer-logo, .footer-contact, .footer-links {
    width: 100%;
    margin-bottom: 30px;
  }
}
</style> 